// function to calculate width for each element
export const spendPercentage = (
  firstAmount: number,
  otherAmount: number,
): number => (otherAmount / firstAmount) * 100;
